import React, {useContext, useEffect, useState} from 'react';
import useAxios from 'axios-hooks';
import SideDrawer from '../../Components/Advertisers/SideDrawer';
import ContentDiv from '../../Components/Universal/ContentDiv'
import CustomText from '../../Components/Universal/CustomText'
import AccountSettingsForm from '../../Components/Advertisers/AccountSettingsForm'
import {DashboardContext} from "./Dashboard/context";
import {Container, Divider} from "@material-ui/core";
import PasswordResetForm from "../../Components/Advertisers/PasswordResetForm";
import {updateAdvertiser, updateAdvertiserPassword} from "../../Api";

const AccountSettings = props => {
  const {advertiser} = useContext(DashboardContext);

  const [accountForm, setAccountForm] = useState({
    first_name: advertiser.advertiser_first_name,
    last_name: advertiser.advertiser_last_name,
    business_name: advertiser.advertiser_business_name,
    business_category: advertiser.advertiser_business_category,
    phone_number: advertiser.phone_number,
    address1: advertiser.advertiser_address1,
    address2: advertiser.advertiser_address2,
    city: advertiser.advertiser_city,
    state: advertiser.advertiser_state,
    zip: advertiser.advertiser_zip,
  });
  const [savingAccountError, setSavingAccountError] = useState('');
  const [savingAccountSuccess, setSavingAccountSuccess] = useState(false);

  const [passwordForm, setPasswordForm] = useState({
    email: advertiser.advertiser_email,
    password: '',
    password2: ''
  });
  const [savingPasswordError, setSavingPasswordError] = useState('');
  const [savingPasswordSuccess, setSavingPasswordSuccess] = useState(false);

  const [{data: accountRes, loading: savingAccount, error: accountError}, updateAccountAction] = useAxios(updateAdvertiser(), {manual: true});
  const [{data: passwordRes, loading: savingPassword, error: passwordError}, updatePasswordAction] = useAxios(updateAdvertiserPassword(), {manual: true});

  useEffect(() => {
    let errorMsg = false;
    if (accountRes) {
      if (!accountRes.error) {
        setSavingAccountSuccess(true);
        setSavingAccountError('');
      } else {
        errorMsg = true;
      }
    } else if (accountError) {
      errorMsg = true;
    }

    if (errorMsg) {
      setSavingAccountSuccess(false);
      setSavingAccountError('Unable to save account, please try again later...');
    }
  }, [accountRes, accountError]);

  useEffect(() => {
    let errorMsg = false;
    if (passwordRes) {
      if (!passwordRes.error) {
        setSavingPasswordSuccess(true);
        setSavingPasswordError('');
      } else {
        errorMsg = true;
      }
    } else if (passwordError) {
      errorMsg = true;
    }

    if (errorMsg) {
      setSavingPasswordSuccess(false);
      setSavingPasswordError('Unable to save account, please try again later...');
    }
  }, [passwordRes, passwordError]);

  const fieldChange = e => {
    setAccountForm({...accountForm, [e.target.name]: e.target.value});
  };

  const fieldChangePass = e => {
    setPasswordForm({...passwordForm, [e.target.name]: e.target.value});
  };

  const handleSave = (e) => {
    e.preventDefault();
    setSavingAccountError('');
    const data = {};
    Object.keys(accountForm).map(k => data[`advertiser_${k}`] = accountForm[k]);
    updateAccountAction({ data });
  };

  const handlePasswordSave = (e) => {
    e.preventDefault();
    if (passwordForm.password.length < 8) {
      setSavingPasswordError("Password should be not less than 8 characters");
      return;
    }

    if (passwordForm.password !== passwordForm.password2) {
      setSavingPasswordError("Passwords are not matching. Please make sure Password and Confirm Password fields are the same");
      return;
    }

    setSavingPasswordError('');
    updatePasswordAction({data: { password: passwordForm.password, email: passwordForm.email }});
  };

  return (
    <SideDrawer>
      <ContentDiv>
        <Container component="main" maxWidth="xs">
          <CustomText
            text='Account Settings'
            style='titleLarge'
            margin='90px 0 0 0'
          />
          <AccountSettingsForm
            onSubmit={handleSave}
            formData={accountForm}
            onChange={fieldChange}
            loading={savingAccount}
            errorMsg={savingAccountError}
            success={savingAccountSuccess}
            submitText="Update Account"
          />
          <p>&nbsp;</p>
          <Divider />
          <CustomText
            text='Account Credentials'
            style='titleLarge'
            margin='90px 0 0 0'
          />
          <PasswordResetForm
            success={savingPasswordSuccess}
            errorMsg={savingPasswordError}
            loading={savingPassword}
            onChange={fieldChangePass}
            formData={passwordForm}
            onSubmit={handlePasswordSave}
            submitText='Update Credentials'
          />
        </Container>
      </ContentDiv>
    </SideDrawer>
  )
};

export default AccountSettings
